import moment from "moment";
import { isGroupChat } from "./ChatHelper";
import {
  MSG_PROCESSING_STATUS_ID, MSG_SENT_ACKNOWLEDGE_STATUS_ID,
  MSG_DELIVERED_STATUS_ID, MSG_SEEN_STATUS_ID, CHAT_TYPE_GROUP, GROUP_CREATED,
  GROUP_USER_ADDED, GROUP_USER_REMOVED, GROUP_USER_LEFT,
  GROUP_PROFILE_INFO_UPDATED, GROUP_USER_MADE_ADMIN
} from './Constant';
import { isLocalUser, getDataFromRoster, getContactNameFromRosterUpdate, setUserAsRoster, formatUserIdToJid } from "./User";
import i18n from "../../MainApp/features/Languages/i18n";
import { getFromLocalStorageAndDecrypt } from "Components/WebChat/WebChatEncryptDecrypt";
import Store from "Store";
import { chatResetMessage } from "Actions/GroupChatMessageActions";
import { ActiveChatAction } from "Actions/RecentChatActions";
window.moment = moment;

export const sortBydate = (chatMessages) => {
  return chatMessages.sort((a, b) => (b.timestamp > a.timestamp ? 1 : -1));
};

export const sortBydatenewChat = (newMessages) => {
  return newMessages.sort((a, b) => {
    const { recent: firstchat } = a;
    const { recent: secondchat } = b;
    return new Date(secondchat.time.replace(/ /g, "T")).getTime() >
      new Date(firstchat.time.replace(/ /g, "T")).getTime()
      ? 1
      : -1;
  });
};

export const handleSplitUserId = (userId) => userId && userId.split("@").shift();

export const messageNotification = ["sentMessage", "carbonSentMessage", "carbonReceiveMessage", "receiveMessage"];

export const isRenderMessageType = (messageType) => {
  return (
    ["sentMessage", "carbonSentMessage", "carbonReceiveMessage", "receiveMessage", "carbonSentSeen"].indexOf(
      messageType
    ) === -1
  );
};

export const changeTimeFormat = (time) => {
  if(!time){
    return '';
  }
  else if(time.toString().length === 16) {
    return moment((time / 1000000) * 1000)
    .utc()
    .format("YYYY-MM-DD HH:mm:ss");
  } else {
    return moment(time)
    .utc()
    .format("YYYY-MM-DD HH:mm:ss");
  }
};

export const timeFormat = (time) => {
  let offset = moment().utcOffset();
  return moment.utc(time).utcOffset(offset).format("MM/DD/YYYY [at] h:mm:ss A");
};

export const receiveNotification = ["delivered", "receive", "carbonDelivered"];

export const messageDeliveryStatus = {
  [MSG_SENT_ACKNOWLEDGE_STATUS_ID]: "user-status-sent",
  [MSG_DELIVERED_STATUS_ID]: "user-status-receive",
  [MSG_SEEN_STATUS_ID]: "user-status",
  [MSG_PROCESSING_STATUS_ID]: "msg-processing"
};

/**
 * keepin the order of the message delivery status
 * 3 - processing, 0 - sent, 1 - delivered to remote user, 2 - seen by remote user
 */
export const msgStatusOrder = [MSG_PROCESSING_STATUS_ID,MSG_SENT_ACKNOWLEDGE_STATUS_ID,MSG_DELIVERED_STATUS_ID,MSG_SEEN_STATUS_ID];

export const groupstatus = (publisherId, toUserId, status, roster, chatType = CHAT_TYPE_GROUP) => {
  const {t} = i18n
  const publisherNameObj = getContactNameFromRosterUpdate(getDataFromRoster(publisherId), true);
  const publisherName = publisherNameObj.consolidatedName;
  const nameObj = getContactNameFromRosterUpdate(getDataFromRoster(toUserId), true);
  const toUserName = nameObj.consolidatedName;
  const groupName = isGroupChat(chatType) ? t('infotext.thisgroup') : t('infotext.broadcast');
  const isPublisherLocalUser = isLocalUser(publisherId);
  const isToUserLocalUser = isLocalUser(toUserId);
  let msgContent;
  if (status === GROUP_CREATED) {
    if (isPublisherLocalUser) {
      msgContent = `${t('infotext.youcreated')} ${groupName}`;
    } else {
      msgContent = `${publisherName} ${t('infotext.created')} ${groupName}`;
    }
  } else if (status === GROUP_USER_ADDED) {
    if (isPublisherLocalUser) {
      msgContent = t('infotext.youadded');
    } else {
      msgContent = `${publisherName} ${t('infotext.added')}`;
    }
    if (isToUserLocalUser) {
      if (!isPublisherLocalUser) {
        msgContent = `${msgContent} ${t('label.you')}`;
      } else {
        msgContent = "";
      }
    } else {
      msgContent = msgContent + " " + toUserName;
    }
  } else if (status === GROUP_USER_REMOVED || status === GROUP_USER_LEFT) {
    if (isPublisherLocalUser) {
      msgContent = `${t('label.you') }`;
    } else {
      msgContent = publisherName;
    }
    if (isToUserLocalUser) {
      if (isPublisherLocalUser) {
        msgContent = `${msgContent} ${t('common.text.left')} `;
      } else {
        msgContent = `${msgContent} ${t('common.text.removedyou')}`;
      }
    } else {
      if (isPublisherLocalUser) {
        msgContent = `${msgContent} ${t('common.text.removed')} ${toUserName}`;
      } else {
        if (toUserId === publisherId) {
          msgContent = `${msgContent} ${t('common.text.left')} `;
        } else {
          msgContent = `${msgContent} ${t('common.text.removed')} ${toUserName}`;
        }
      }
    }
  } else if (status === GROUP_PROFILE_INFO_UPDATED) {
    if (isPublisherLocalUser) {
      msgContent = `${t('common.text.youupdated')} ${groupName} ${t('common.text.profile')}`;
      
    } else {
      msgContent = `${publisherName} ${t('common.text.updated')} ${groupName} ${t('common.text.profile')}`;
    }
  } else if (status === GROUP_USER_MADE_ADMIN) {
    if (isToUserLocalUser) {
      msgContent = t('infotext.youarenowanadmin');
    } else {
      msgContent = `${toUserName} ${t('infotext.isnowanadmin')}`;
    }
  }
  return msgContent;
};

export const handleMessageParseHtml = (msg = "") => {
  const escapedString = msg.replace(/</g, '&lt;').replace(/>/g, '&gt;');
  const parseResult = new DOMParser().parseFromString(escapedString, "text/html");
  return parseResult && parseResult.documentElement.textContent;
}

export const renderDisplayName = (displayName, registeredName) => {
  if(typeof displayName === 'string'){
    return `${displayName}${ registeredName ? ` ~${registeredName}`: '' }`;
  } else if(Array.isArray(displayName) && registeredName) {
    displayName.push(<span>{` ~${registeredName}`}</span>)
  }
  return displayName
}

export const initiateNewChat = (user, callback) => {
  const recordingStatus = getFromLocalStorageAndDecrypt('recordingStatus')
        if (recordingStatus === 'false') return;
        let data = {
            roster: user,
            recent: {
                chatType: "chat"
            }
        }
        setUserAsRoster(user);
        Store.dispatch(chatResetMessage()).then(() => {
            data.chatType = "chat";
            data.chatId = user.userId;
            data.chatJid = formatUserIdToJid(user.userId);
            Store.dispatch(ActiveChatAction(data));
            if(callback){
              callback();
            }
        });
}